import { Decisions, FeatureDecisions, isDecisionKey } from '@aloft/toolkit-shared';
import { createSlice } from '@reduxjs/toolkit';

export const initialFeaturesState: { [k in keyof FeatureDecisions]: boolean } = Object.keys(
  Decisions,
)
  .filter(isDecisionKey)
  .reduce(
    (acc, key) => ({ ...acc, [key]: false }),
    {} as { [k in keyof FeatureDecisions]: boolean },
  );

const isDifferent = (a: typeof initialFeaturesState, b: typeof initialFeaturesState) =>
  Object.keys(a).some(
    (key) => a[key as keyof FeatureDecisions] !== b[key as keyof FeatureDecisions],
  );

const featuresSlice = createSlice({
  name: 'features',
  initialState: initialFeaturesState,
  reducers: {
    loadFeatures(state, action) {
      if (isDifferent(action.payload, state)) {
        return { ...action.payload };
      }
    },
  }
});

export const { loadFeatures } = featuresSlice.actions;

export const featuresReducer = featuresSlice.reducer;
